import _ from 'lodash';

const expansionOptionsConfig = [{
  //////////////////////////////////////////////////////////////////////////////////
  // Standard Options
  //////////////////////////////////////////////////////////////////////////////////

  key: 'temporaryEnchant',
  name: 'Weapon Rune',
  description: (
    'For dual wielders, the single choice options will apply to both weapons.' +
    ' Crafted enchants are simmed at crafting quality 3'
  ),
  icon: 'inv_misc_potionseta',

  simcOption: 'temporary_enchant',

  type: 'string',
  default: '',

  presets: {
    optimalRaid: '',
    targetDummy: 'disabled',
  },

  values: [{
    value: '',
    name: 'SimC Default',
  }, {

    // TODO: Use GameData.TempEnchants - requires some thinking to make this all work after preload

    // THE WAR WITHIN

    value: 'main_hand:ironclaw_whetstone_3',
    name: '[Main Hand] Ironclaw Whetstone (AP)',
  }, {
    value: 'main_hand:oil_of_deep_toxins_3',
    name: '[Main Hand] Oil of Deep Toxins (Direct Damage)',
  }, {
    value: 'main_hand:algari_mana_oil_3',
    name: '[Main Hand] Algari Mana Oil (Crit/Haste)',
  }, {
    value: 'main_hand:ironclaw_whetstone_3/off_hand:ironclaw_whetstone_3',
    name: '[Dual Wield] Ironclaw Whetstone (AP)',
    dualWield: true,
  }, {
    value: 'main_hand:oil_of_deep_toxins_3/off_hand:oil_of_deep_toxins_3',
    name: '[Dual Wield] Oil of Deep Toxins (Direct Damage)',
    dualWield: true,
  }, {
    value: 'main_hand:algari_mana_oil_3/off_hand:algari_mana_oil_3',
    name: '[Dual Wield] Algari Mana Oil (Crit/Haste)',
    dualWield: true,
  }, {
    value: 'main_hand:ironclaw_whetstone_3/off_hand:oil_of_deep_toxins_3',
    name: '[Dual Wield] Ironclaw Whetstone (AP) / Oil of Deep Toxins (Direct Damage)',
    dualWield: true,
  }, {
    value: 'main_hand:ironclaw_whetstone_3/off_hand:algari_mana_oil_3',
    name: '[Dual Wield] Ironclaw Whetstone (AP) / Algari Mana Oil (Crit/Haste)',
    dualWield: true,
  }, {
    value: 'main_hand:oil_of_deep_toxins_3/off_hand:algari_mana_oil_3',
    name: '[Dual Wield] Oil of Deep Toxins (Direct Damage) / Algari Mana Oil (Crit/Haste)',
    dualWield: true,

    // DRAGONFLIGHT

  }, {
    value: 'main_hand:primal_whetstone_3',
    name: 'Dragonflight - AP (Main Hand)',
  }, {
    value: 'main_hand:primal_whetstone_3/off_hand:primal_whetstone_3',
    name: 'Dragonflight - AP (Both Hands)',
    dualWield: true,
  }, {
    value: 'main_hand:primal_whetstone_3/off_hand:buzzing_rune_3',
    name: 'Dragonflight - AP + Buzzing (Crit)',
    dualWield: true,
  }, {
    value: 'main_hand:primal_whetstone_3/off_hand:howling_rune_3',
    name: 'Dragonflight - AP + Howling (Haste)',
    dualWield: true,
  }, {
    value: 'main_hand:primal_whetstone_3/off_hand:hissing_rune_3',
    name: 'Dragonflight - AP + Hissing (Mastery)',
    dualWield: true,
  }, {
    value: 'main_hand:howling_rune_3/off_hand:hissing_rune_3',
    name: 'Dragonflight - Howling (Haste) + Hissing (Mastery)',
    dualWield: true,
  }, {
    value: 'main_hand:buzzing_rune_3/off_hand:hissing_rune_3',
    name: 'Dragonflight - Buzzing (Crit) + Hissing (Mastery)',
    dualWield: true,
  }, {
    value: 'main_hand:buzzing_rune_3/off_hand:howling_rune_3',
    name: 'Dragonflight - Buzzing (Crit) + Howling (Haste)',
    dualWield: true,
  }, {
    value: 'main_hand:hissing_rune_3/off_hand:hissing_rune_3',
    name: 'Dragonflight - Hissing (Mastery) (Both Hands)',
    dualWield: true,
  }, {
    value: 'main_hand:howling_rune_3/off_hand:howling_rune_3',
    name: 'Dragonflight - Howling (Haste) (Both Hands)',
    dualWield: true,
  }, {
    value: 'main_hand:buzzing_rune_3/off_hand:buzzing_rune_3',
    name: 'Dragonflight - Buzzing (Crit) (Both Hands)',
    dualWield: true,
  }, {
    value: 'main_hand:hissing_rune_3',
    name: 'Dragonflight - Hissing (Mastery) (Main Hand)',
  }, {
    value: 'main_hand:buzzing_rune_3',
    name: 'Dragonflight - Buzzing (Crit) (Main Hand)',
  }, {
    value: 'main_hand:howling_rune_3',
    name: 'Dragonflight - Howling (Haste) (Main Hand)',
  }, {
    value: 'main_hand:completely_safe_rockets_3',
    name: 'Dragonflight - Completely Safe Rockets (Hunter)',
  }, {
    value: 'main_hand:endless_stack_of_needles_3',
    name: 'Dragonflight - Endless Stack of Needles (Hunter)',

    /*
  }, {
    value: 'main_hand:shadowcore_oil',
    name: 'Dragonflight - Shadowlands: Shadowcore Oil (Main Hand)',
  }, {
    value: 'main_hand:shadowcore_oil/off_hand:shadowcore_oil',
    name: 'Shadowlands: Shadowcore Oil (Both hands)',
    dualWield: true,
  }, {
    value: 'main_hand:shaded_sharpening_stone',
    name: 'Shadowlands: +20 AP (Main Hand)',
  }, {
    value: 'main_hand:shaded_sharpening_stone/off_hand:shaded_sharpening_stone',
    name: 'Shadowlands: +20 AP (Both hands)',
    dualWield: true,
  }, {
    value: 'main_hand:porous_sharpening_stone',
    name: 'Shadowlands: +16 AP (Main Hand)',
  }, {
    value: 'main_hand:porous_sharpening_stone/off_hand:porous_sharpening_stone',
    name: 'Shadowlands: +16 AP (Both hands)',
    dualWield: true,
  }, {
    value: 'main_hand:shaded_sharpening_stone/off_hand:shadowcore_oil',
    name: 'Shadowlands: +20 AP + Shadowcore Oil',
    dualWield: true,
  */

  }, {
    value: 'disabled',
    name: 'Disabled',
  }],

}, {

  //////////////////////////////////////////////////////////////////////////////////
  // The War Within Options
  //////////////////////////////////////////////////////////////////////////////////

  key: 'dawnDuskThreadLining',
  name: 'Dawn/Duskthread Lining Uptime',
  description: 'Percent of time the player is above 80% health',

  itemId: '222868',
  icon: 'inv_10_tailoring_silkrare_color1',

  simcOption: 'thewarwithin.dawn_dusk_thread_lining_uptime',

  type: 'int',
  default: 60,

  values: _.map(_.reverse(_.range(0, 101, 5)), pct => ({
    value: pct,
    name: `${pct}%`,
  })),

  simcTransform: pct => (pct ? _.round(pct / 100, 2) : 0),

}, {

  //////////////////////////////////////////////////////////////////////////////////
  // Dragonflight Options
  //////////////////////////////////////////////////////////////////////////////////

  key: 'balefireBranchRngType',
  name: 'Balefire Branch Uptime',
  description: 'Controls how the simulation will trigger stack losses',

  itemId: 159630,
  icon: 'inv_staff_26',

  simcOption: 'dragonflight.balefire_branch_loss_rng_type',

  type: 'string',
  default: 'constant',

  values: [{
    value: 'constant',
    name: 'Default (Lower Uptime)',
    description: 'Simulates constant incoming damage (e.g. unavoidable raid damage ticks).',
  }, {
    value: 'rppm',
    name: 'Dungeon (Higher Uptime)',
    description: 'Simulates using the trinket at times with less incoming damage.',
  }],

  archived: true,
  disabled: true,

}, {

  key: 'ominousChromaticEssencePersonal',
  name: 'Ominous Chromatic Essence Dragonflight',
  description: 'Your sworn Dragonflight',

  itemId: '203729',
  icon: 'inv_misc_orb_blue',

  simcOption: 'dragonflight.ominous_chromatic_essence_dragonflight',

  type: 'string',
  default: 'obsidian',

  values: [{
    value: 'obsidian',
    name: 'Obsidian (all secondary stats)',
  }, {
    value: 'emerald',
    name: 'Emerald (crit)',
  }, {
    value: 'bronze',
    name: 'Bronze (haste)',
  }, {
    value: 'azure',
    name: 'Azure (mastery)',
  }, {
    value: 'ruby',
    name: 'Ruby (versatility)',
  }],

  archived: true,
  disabled: true,

}, {

  key: 'ominousChromaticEssenceAllies',
  name: 'Ominous Chromatic Essence Allies',
  description: 'Ally Dragonflights sworn - can fully customize in Custom APL and SimC Options section',

  itemId: '203729',
  icon: 'inv_misc_orb_blue',

  simcOption: 'dragonflight.ominous_chromatic_essence_allies',

  type: 'string',
  default: '',

  values: [{
    value: '',
    name: 'No Ally Buffs',
  }, {
    value: 'obsidian/emerald/bronze/azure/ruby',
    name: 'All Ally Buffs',
  }],

  archived: true,
  disabled: true,

}, {

  key: 'blueSilkenLining',
  name: 'Blue Silken Lining Uptime',
  description: 'Percent of time the player is above 90% health',

  itemId: '193944',
  icon: 'inv_10_tailoring_silkrare_color1',

  simcOption: 'dragonflight.blue_silken_lining_uptime',

  type: 'int',
  default: 40,

  values: _.map(_.reverse(_.range(0, 101, 5)), pct => ({
    value: pct,
    name: `${pct}%`,
  })),

  simcTransform: pct => (pct ? _.round(pct / 100, 2) : 0),

  archived: true,
  disabled: true,

}, {

  key: 'corruptingRageUptime',
  name: 'Corrupting Rage Uptime',
  description: 'Percent of uptime of the crit buff from  Phial of Corrupting Rage',

  itemId: 191327,
  icon: 'inv_10_alchemy_bottle_shape2_red',

  simcOption: 'dragonflight.corrupting_rage_uptime',

  type: 'int',
  default: 80,

  values: _.map(_.reverse(_.range(10, 101, 5)), pct => ({
    value: pct,
    name: `${pct}%`,
  })),

  simcTransform: pct => (pct ? _.round(pct / 100, 2) : 0),

  archived: true,
  disabled: true,

}, {

  key: 'rubyWhelpShellTraining',
  name: 'Ruby Whelp Shell Training',
  description: 'Test full training (6 days). Can be overridden with custom training in Custom APL and SimC Options',

  itemId: 193757,
  icon: 'inv_item_dragonegg_redbroken01',

  simcOption: 'dragonflight.ruby_whelp_shell_training',

  type: 'string',
  default: '',

  values: [{
    value: '',
    name: 'None (Random Ability Usage)',
  }, {
    value: 'fire_shot:6',
    name: 'Fire Shot (Single target damage)',
  }, {
    value: 'lobbing_fire_nova:6',
    name: 'Lobbing Fire Nova (AOE damage)',
  }, {
    value: 'sleepy_ruby_warmth:6',
    name: 'Sleepy Ruby Warmth (Crit buff)',
  }, {
    value: 'under_red_wings:6',
    name: 'Under Red Wings (Haste buff)',
  }, {
    value: 'curing_whiff:6',
    name: 'Curing Whiff (Single target healing)',
  }, {
    value: 'mending_breath:6',
    name: 'Mending Breath (AOE healing)',
  }],

  archived: true,
  disabled: true,

}, {

  key: 'primalRitualShell',
  name: 'Primal Ritual Shell',
  description: 'Which blessing from the trinket. Only Wind and Flame affect DPS',

  itemId: 200563,
  icon: 'inv_10_dungeonjewelry_titan_trinket_2_color1',

  simcOption: 'dragonflight.primal_ritual_shell_blessing',

  type: 'string',
  default: 'wind',

  values: [{
    value: 'wind',
    name: 'Wind (Mastery proc)',
  }, {
    value: 'flame',
    name: 'Flame (Fire damage proc)',
  }],

  archived: true,
  disabled: true,

}, {

  key: 'whisperingIncarnateIconRoles',
  name: 'Whispering Incarnate Icon Roles',
  description: 'Which roles in your group have the Whispering Incarnate Icon trinket',

  itemId: 194301,
  icon: 'inv_10_dungeonjewelry_primalist_necklace_1_omni',

  simcOption: 'dragonflight.whispering_incarnate_icon_roles',

  type: 'string',
  default: 'dps/heal/tank',

  values: [{
    value: '',
    name: 'None',
  }, {
    value: 'dps',
    name: 'DPS',
  }, {
    value: 'tank',
    name: 'Tank',
  }, {
    value: 'heal',
    name: 'Healer',
  }, {
    value: 'dps/tank',
    name: 'DPS + Tank',
  }, {
    value: 'dps/heal',
    name: 'DPS + Healer',
  }, {
    value: 'tank/heal',
    name: 'Tank + Healer',
  }, {
    value: 'dps/heal/tank',
    name: 'DPS + Tank + Healer',
  }],

  archived: true,
  disabled: true,

}, {


  //////////////////////////////////////////////////////////////////////////////////
  // Shadowlands Options - 9.2
  //////////////////////////////////////////////////////////////////////////////////

  key: 'enableDominationShards',
  name: 'Domination Shards',
  description: 'Enables Domination Shards for 9.1 content',
  icon: 'spell_priest_mindspike',

  simcOption: 'shadowlands.enable_domination_gems',

  type: 'bool',
  default: false,

  archived: true,
  disabled: true,

}, {

  //////////////////////////////////////////////////////////////////////////////////
  // Shadowlands Options - 9.1
  //////////////////////////////////////////////////////////////////////////////////

  key: 'soleahStatType',
  name: 'So\'leah\'s Secret Technique Stat',
  description: 'Determine the secondary stat that Soleah\'s will provide',

  icon: 'inv_60pvp_trinket1d',

  simcOption: 'shadowlands.soleahs_secret_technique_type',

  type: 'string',
  default: 'haste',

  values: [{
    value: 'haste',
    name: 'Haste',
  }, {
    value: 'crit',
    name: 'Crit',
  }, {
    value: 'mastery',
    name: 'Mastery',
  }, {
    value: 'versatility',
    name: 'Versatility',
  }],

  archived: true,
  disabled: true,

}, {

  key: 'ocularGlandUptime',
  name: 'Ocular Gland Health Uptime',
  description: 'Percent of time the player is above 50% health',

  icon: 'spell_holy_healingfocus',

  simcOption: 'shadowlands.titanic_ocular_gland_worthy_chance',

  type: 'int',
  default: 100,

  values: _.map(_.reverse(_.range(0, 101, 5)), pct => ({
    value: pct,
    name: `${pct}%`,
  })),

  simcTransform: pct => (pct ? _.round(pct / 100, 2) : null),

  archived: true,
  disabled: true,

}, {

  key: 'enableRuneWords',
  name: 'Domination Shard Set Bonuses',
  description: 'Enables the set bonuses from Domination gear. Disable to sim M+.',
  icon: 'spell_priest_mindspike',

  simcOption: 'shadowlands.enable_rune_words',

  type: 'bool',
  default: false,

  archived: true,
  disabled: true,

}, {

  //////////////////////////////////////////////////////////////////////////////////
  // Shadowlands Options - 9.0
  //////////////////////////////////////////////////////////////////////////////////

  key: 'stoneLegionHeraldryInParty',
  name: 'Stone Legion Heraldries in Party',
  description: 'Number of other players (not including you) in your party with Stone Legion Heraldry trinket',

  icon: 'inv_leather_raiddruid_o_01chest',

  simcOption: 'shadowlands.stone_legionnaires_in_party',

  type: 'int',
  default: 0,

  values: _.map(_.range(0, 5), players => ({
    value: players,
    name: players,
  })),

  archived: true,
  disabled: true,

}, {

  key: 'cabalistsHymnalInParty',
  name: 'Cabalist\'s Hymnal in Party',
  description: 'Number of other players (not including you) in your party with Cabalist\'s Hymnal trinket',

  icon: 'inv_artifact_tome01',

  simcOption: 'shadowlands.crimson_choir_in_party',

  type: 'int',
  default: 0,

  values: _.map(_.range(0, 5), players => ({
    value: players,
    name: players,
  })),

  archived: true,
  disabled: true,

}, {

  key: 'disableIqdExecute',
  name: 'Disable IQD Execute',
  description: 'IQD will never proc the execute damage on the boss. Enable this if you use a self-target macro for IQD',

  icon: 'inv_trinket_80_titan02a',

  simcOption: 'shadowlands.disable_iqd_execute',

  type: 'bool',
  default: false,

  archived: true,
  disabled: true,

}, {

  key: 'iqdStatFailChance',
  name: 'IQD Stat Proc Chance',
  description: 'Chance that subsequent IQD uses will proc stats. First use during bloodlust will always sim stats',

  icon: 'inv_trinket_80_titan02a',

  simcOption: 'shadowlands.iqd_stat_fail_chance',

  type: 'int',
  default: 0,

  values: _.map(_.reverse(_.range(0, 101, 10)), pct => ({
    value: (100 - pct),
    name: `${pct}%`,
  })),

  simcTransform: pct => _.round(pct / 100, 2),

  archived: true,
  disabled: true,

}, {

  key: 'unboundChangelingStatType',
  name: 'Unbound Changeling Proc',
  description: 'Override how the sim will handle Unbound Changeling',

  icon: 'spell_animaardenweald_nova',

  simcOption: 'shadowlands.unbound_changeling_stat_type',

  type: 'string',
  default: '',

  values: [{
    value: '',
    name: 'Default',
    description: (
      'Uses bonus ID first, falls back to haste proc'
    ),
  }, {
    value: 'all',
    name: 'Crit, haste, mastery',
    description: 'Overrides the proc on your current trinket',
  }, {
    value: 'crit',
    name: 'Crit',
    description: 'Overrides the proc on your current trinket',
  }, {
    value: 'haste',
    name: 'Haste',
    description: 'Overrides the proc on your current trinket',
  }, {
    value: 'mastery',
    name: 'Mastery',
    description: 'Overrides the proc on your current trinket',
  }],

  archived: true,
  disabled: true,

}, {

  //////////////////////////////////////////////////////////////////////////////////
  // BfA Options
  //////////////////////////////////////////////////////////////////////////////////

  key: 'nazjatar',
  name: 'In Nazjatar',
  description: 'Enables Nazjatar Benthic armor effects',

  simcOption: 'bfa.nazjatar',

  type: 'bool',
  default: false,

  archived: true,
  disabled: true,

}, {

  key: 'worldveinAllies',
  name: 'Worldvein Allies',

  simcOption: 'bfa.worldvein_allies',

  type: 'int',
  default: 0,

  description: (
    'Number of allies (not including you) with Worldvein Resonance.' +
    ' Only active when you have Worldvein Resonance selected.'
  ),
  values: _.map(_.range(0, 11, 1), value => ({
    value,
    name: value,
  })),

  archived: true,
  disabled: true,
}, {

  key: 'loyalToTheEndAllies',
  name: 'Loyal to the End Allies',

  simcOption: 'bfa.loyal_to_the_end_allies',

  type: 'int',
  default: 0,

  description: (
    'Number of allies (not including you) with Loyal to the End Azerite trait.' +
    ' Only active when you have Loyal to the End trait active.'
  ),
  values: _.map(_.range(0, 5, 1), value => ({
    value,
    name: value,
  })),

  archived: true,
  disabled: true,

}, {

  key: 'covenantChance',
  name: 'Treacherous Covenant',

  simcOption: 'bfa.covenant_chance',
  simcTransform: cc => _.round(cc / 100, 2),

  type: 'int',
  default: 100,

  values: _.map(_.reverse(_.range(0, 101, 5)), pct => ({
    value: pct,
    name: `${pct}%`,
    description: 'Uptime of Treacherous Covenent beneficial buff (HP over 50%)',
  })),

  archived: true,
  disabled: true,

}, {

  key: 'undulatingTides',
  name: 'Undulating Tides Effectiveness',

  simcOption: 'bfa.undulating_tides_lockout_chance',
  simcTransform: value => {
    if (_.isUndefined(value)) {
      return null;
    }
    const valueMap = {
      0: 1,
      10: 0.5,
      20: 0.35,
      30: 0.225,
      40: 0.15,
      50: 0.1,
      60: 0.075,
      70: 0.04,
      80: 0.03,
      90: 0.015,
      100: 0,
    };
    if (_.has(valueMap, value)) {
      return [
        ['bfa.undulating_tides_lockout_timer', 5],
        ['bfa.undulating_tides_lockout_chance', valueMap[value]],
      ];
    }
    return value;
  },

  type: 'int',
  default: 100,

  description: (
    'How often Undulating Tides will damage when proccing. Roughly corresponds to the inverse of the debuff'
  ),
  values: _.map(_.range(0, 101, 10), pct => ({
    value: pct,
    name: `${pct}%`,
  })),

  archived: true,
  disabled: true,

}, {

  key: 'nyalotha',
  name: 'In Ny\'alotha',
  description: 'Enables Ra-den trinket set bonus',

  simcOption: 'bfa.nyalotha',

  type: 'bool',
  default: true,

  archived: true,
  disabled: true,
}, {

  key: 'aberration',
  name: 'Aberration',
  description: 'All enemies are aberrations',

  simcOption: 'target_race',
  simcTransform: value => {
    if (value) {
      return 'aberration';
    }
    return null;
  },

  type: 'bool',
  default: false,

  archived: true,
  disabled: true,
}, {

  key: 'voidRitual',
  name: 'Void Ritual Allies',
  description: 'Enables increased proc chance of this corruption',

  simcOption: 'bfa.void_ritual_increased_chance_active',

  type: 'bool',
  default: false,

  archived: true,
  disabled: true,
}, {

  key: 'surgingVitality',
  name: 'Surging Vitality Uptime',

  simcOption: 'bfa.surging_vitality_damage_taken_period',

  type: 'int',
  default: 0,

  description: (
    'Uptime of Surging Vitality corruption buff, corresponds to how often you take damage'
  ),
  values: [{
    value: 0,
    name: '0%',
  }, {
    value: 65,
    name: '15%',
  }, {
    value: 31,
    name: '20%',
  }, {
    value: 19,
    name: '25%',
  }, {
    value: 12,
    name: '30%',
  }, {
    value: 8,
    name: '35%',
  }, {
    value: 6,
    name: '40%',
  }, {
    value: 5,
    name: '45%',
  }, {
    value: 4,
    name: '50%',
  }, {
    value: 3,
    name: '55%',
  }],
  simcTransform: value => {
    if (value) {
      return value;
    }
    return null;
  },

  archived: true,
  disabled: true,
}, {

  key: 'symbioticPresence',
  name: 'Symbiotic Presence Uptime',

  simcOption: 'bfa.symbiotic_presence_interval',

  type: 'int',
  default: 22,

  description: (
    'Uptime of Symbiotic Presence (buff from Formless Void minor). Corresponds with party/raid Heart ability usage'
  ),
  values: [{
    value: 20,
    name: '100%',
  }, {
    value: 22,
    name: '90%',
  }, {
    value: 25,
    name: '80%',
  }, {
    value: 29,
    name: '70%',
  }, {
    value: 34,
    name: '60%',
  }, {
    value: 41,
    name: '50%',
  }, {
    value: 52,
    name: '40%',
  }, {
    value: 72,
    name: '30%',
  }, {
    value: 114,
    name: '20%',
  }, {
    value: 273,
    name: '10%',
  }],

  archived: true,
  disabled: true,
}];

export const findExpacOption = key => _.find(expansionOptionsConfig, { key });

export const expacOptionType = key => {
  const opt = findExpacOption(key);

  const name = _.toUpper(_.snakeCase(opt.key));

  return `SET_XOPTION_${name}`;
};

export const expacOptionTypeStr = key => {
  const opt = findExpacOption(key);

  const name = _.snakeCase(opt.key);

  return `raidbots/simbot/expansion_option/${name}`;
};

const expansionOptions = _.map(expansionOptionsConfig, opt => {
  return {
    ...opt,
    redux: {
      actionType: expacOptionType(opt.key),
      actionName: expacOptionTypeStr(opt.key),
      actionFunc: `setExpansionOption${_.upperFirst(_.camelCase(opt.key))}`,
    },
  };
});

// generate Redux action types at runtime
export const expansionOptionActionTypes = _.fromPairs(_.map(expansionOptions, opt => {
  return [
    opt.redux.actionType,
    opt.redux.actionName,
  ];
}));

export default expansionOptions;
